module.exports = __webpack_public_path__ + "img/caso2.06e3d595.png";